import React, { useEffect, useState, Fragment} from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { saveCharacter } from '../../../actions/character';


import Modal from 'react-modal';
import ItemStore from '../modals/ItemStore';
import CraftingModal from '../modals/CraftingModal';
import ModModal from '../modals/ModModal';

import arrowImg from '../../../img/Kaleido_Arrow.png';

const CharEditInventory = ({
    item: {
        items
    },
    character: {
        character
    },
    saveCharacter
}) => {

    var [showBuyModal, toggleBuyModal] = useState(false);
    var [showCraftingModal, toggleCraftingModal] = useState(false);
    var [modModal, toggleModModal] = useState({"open": false, "item": {}});
    var [offhandModal, toggleOffhandModal] = useState({"open": false, "item": {}});

    const toggleInvOptions = (index) => (e) => {

        // Make ALL option menus hidden
        var optionMenus = document.getElementsByClassName("invOptMenu");

        var menuArray = Array.from(optionMenus)

        const curId = 'invOptMenu' + index;

        var ele = document.getElementById(curId);

        menuArray.forEach((el) => {
            if(el !== ele){
                el.className = "invOptMenu hidden";
            } else {
                ele.classList.toggle('hidden');
            }
            
        });
    }

    const closeInventoryOptions = () => {
        // Make ALL option menus hidden
        var optionMenus = document.getElementsByClassName("invOptMenu");

        var menuArray = Array.from(optionMenus)

        menuArray.forEach((el) => {
            el.className = "invOptMenu hidden";
        })
    }

    const showInventory = () => {
        var stackables = character.inventory.filter(i => i.stackable);
        var nonstackables = character.inventory.filter(i => !i.stackable);

        stackables = [...new Map(stackables.map(i => [i['name'], i])).values()];

        stackables = stackables.map((item, index) =>
            <div key={item.name + "" + index} className="itemContainer">
                <div className="itemSubcontainer">
                    <p className="itemName">{item.name}</p>
                    <p className="itemType">{item.type}</p>
                    <p className="itemType">{item.subtype}</p>
                </div>
                <div className="itemDesc">
                    <div><p>{item.description}</p></div>
                </div>
                <div className="quantMod">Qty: <span>{character.inventory.filter(i => i.name === item.name).length}</span></div>
                <div className="inventoryOptions">
                    <img  className="invArrow" src={arrowImg} title="Inventory Options" onClick={e=> toggleInvOptions(index)(e)}/>
                    <div id={`invOptMenu`+index} className="invOptMenu hidden">
                        <div className="invOptButton" name="sell" onClick={e => removeItem(item)(e)}>Sell</div>
                        <div className="invOptButton" name="drop" onClick={e => removeItem(item)(e)}>Drop</div>
                        {
                            character.companions.map((comp, ind) =>
                                <div className="invOptButton" name="drop" onClick={e => giveToCompanion(item, comp)(e)}>Give to {comp.name}</div>
                            )
                        }
                        {
                            character.vehicles.map((veh, ind) =>
                                <div className="invOptButton" name="drop" onClick={e => giveToVehicle(item, veh)(e)}>Store in {veh.name}</div>
                            )
                        }
                    </div>
                </div>
                
            </div>
        );

        nonstackables = nonstackables.map((item, index) =>
            { 
                var newInd = index + stackables.length;
                return (
                <div key={item.name + "" + index} className={`itemContainer + ${item.equipped && "equipped"}`}>
                    <div className="itemSubcontainer">
                        <p className="itemName">{item.name}</p>
                        <p className="itemType">{item.type}</p>
                        <p className="itemType">{item.subtype}</p>
                    </div>
                    <div className="itemDesc">
                        {item.classification === "Armor" ?
                            <div>
                                <p>DIS: {item.dis}</p>
                                <p>KIN: {item.kin}</p>
                                {(item.type === "Gloves" || item.type === "Combat Gloves" || item.type === "Power Gaunlet") && <p>Damage: {item.numDice}d{item.diceSize}</p>}
                                <p>Mods: {item.equippedMods.length}/{item.modSlots}</p></div>
                        : item.classification === "Weapon" ?
                            <div>
                                <p>Damage: {item.numDice}d{item.diceSize}</p>
                                {(item.type === "Assault Weapon" || item.type === "Long Range" || item.type === "Pistol") &&
                                <div>
                                    <p>Range: {item.range}m</p>
                                    <p>Mag: {item.currentAmmo}/{item.magSize}</p>
                                </div>
                                }
                                <p>Mods: {item.equippedMods.length}/{item.modSlots}</p>
                            </div>
                        : <div><p>{item.description}</p></div>
                        }
                    </div>
                    <div className="inventoryOptions">
                        <img  className="invArrow" src={arrowImg} title="Inventory Options" onClick={e=> toggleInvOptions(newInd)(e)}/>
                        <div id={`invOptMenu` + newInd} className="invOptMenu hidden">
                            {(item.classification === "Weapon" || "Armor") && !item.equipped ? 
                            (
                                <div className="invOptButton equip" onClick={e => {
                                    item.subtype === "Sidearm" || item.subtype === "Bolt Pistol" || item.subtype === "Hand Cannon" || item.subtype === "Dagger" || item.subtype === "Short Blade" || item.subtype === "Baton" || item.subtype === "Mace" ?
                                    openOffhandModal(item)(e)
                                :
                                    equipItem(character.inventory.findIndex(i => i == item), item)(e)
                                }}>
                                    Equip
                                </div>
                            ) :
                                <div className="invOptButton unequip" onClick={e => unequipItem(item.equipped)(e)}>Unequip</div>
                            }
                            {(item.classification === "Weapon" || "Armor") && item.modSlots > 0 && <div className="invOptButton modify" onClick={e => openModModal(item)(e)}>Modify</div>}
                            <div className="invOptButton" name="sell" onClick={e => removeItem(item)(e)}>Sell</div>
                            <div className="invOptButton" name="drop" onClick={e => removeItem(item)(e)}>Drop</div>
                            {
                                character.companions.map((comp, ind) =>
                                    <div className="invOptButton" name="drop" onClick={e => giveToCompanion(item, comp)(e)}>Give to {comp.name}</div>
                                )
                            }
                            {
                                
                                character.vehicles.map((veh, ind) =>
                                    <div className="invOptButton" name="drop" onClick={e => giveToVehicle(item, veh)(e)}>Store in {veh.name}</div>
                                )
                            }
                            {
                                item.classification === 'Weapon' && 
                                character.vehicles.map((veh, ind) =>
                                    <div className="invOptButton" name="drop" onClick={e => addWeaponToVehicle(item, veh)(e)}>Attach to {veh.name}</div>
                                )
                            }
                        </div>
                    </div>
                </div>
                )
            }
            
        );

        const displayedItems = [...stackables, ...nonstackables];

        return displayedItems;
    }

    const removeItem = (item) => (e) => {

        var newInv = [...character.inventory];
        
        newInv.splice(newInv.findIndex(x => x.name === item.name),1);

        if(e.target.name === "sell"){
            saveCharacter({
                ...character,
                "inventory": newInv,
                "funds": character.funds + item.value,
                "currentCapacity": character.currentCapacity - parseFloat(item.weight.$numberDecimal)
            });
        } else {
            saveCharacter({
                ...character,
                "inventory": newInv,
                "currentCapacity": character.currentCapacity - parseFloat(item.weight.$numberDecimal)
            });
        }

        closeInventoryOptions();
    }

    const equipItem = (ind, item, offhand = false) => (e) => {

        closeModals();

        switch(item.type){
            case "Helmet":
                if(character.inventory.findIndex(i => i.equipped === "Head") > -1){
                    character.inventory[character.inventory.findIndex(i => i.equipped === "Head")].equipped = "";
                };
                character.inventory[ind].equipped = "Head";
                break;
            case "Body":
                if(character.inventory.findIndex(i => i.equipped === "Body") > -1){
                    character.inventory[character.inventory.findIndex(i => i.equipped === "Body")].equipped = "";
                };
                character.inventory[ind].equipped = "Body";
                break;
            case "Gloves":
            case "Combat Gloves":

                if(character.inventory.findIndex(i => i.equipped === "Hands") > -1){
                    character.inventory[character.inventory.findIndex(i => i.equipped === "Hands")].equipped = "";
                };
                character.inventory[ind].equipped = "Hands";
                break;
            case "Boots":
                if(character.inventory.findIndex(i => i.equipped === "Feet") > -1){
                    character.inventory[character.inventory.findIndex(i => i.equipped === "Feet")].equipped = "";
                };
                character.inventory[ind].equipped = "Feet";
                break;
            case "Shield":
                break;
            case "Assault Weapon":
            case "Explosives":
            case "Long Range":
                if(character.inventory.findIndex(i => i.equipped === "Main Hand") > -1){
                    character.inventory[character.inventory.findIndex(i => i.equipped === "Main Hand")].equipped = "";
                };
                if(character.inventory.findIndex(i => i.equipped === "Off Hand") > -1){
                    character.inventory[character.inventory.findIndex(i => i.equipped === "Off Hand")].equipped = "";
                };
                character.inventory[ind].equipped = "Main Hand";
                break;
            case "Blade":
                if(item.subtype === "Long Blade"){
                    if(character.inventory.findIndex(i => i.equipped === "Main Hand") > -1){
                        character.inventory[character.inventory.findIndex(i => i.equipped === "Main Hand")].equipped = "";
                    };
                    if(character.inventory.findIndex(i => i.equipped === "Off Hand") > -1){
                        character.inventory[character.inventory.findIndex(i => i.equipped === "Off Hand")].equipped = "";
                    };
                    character.inventory[ind].equipped = "Main Hand";
                } else if(offhand){
                    if(character.inventory.findIndex(i => i.equipped === "Off Hand") > -1){
                        character.inventory[character.inventory.findIndex(i => i.equipped === "Off Hand")].equipped = "";
                    };
                    character.inventory[ind].equipped = "Off Hand";
                } else {
                    if(character.inventory.findIndex(i => i.equipped === "Main Hand") > -1){
                        character.inventory[character.inventory.findIndex(i => i.equipped === "Main Hand")].equipped = "";
                    };
                    character.inventory[ind].equipped = "Main Hand";
                }
                break;
            case "Blunt":
                if(item.subtype === "Warhammer"){
                    if(character.inventory.findIndex(i => i.equipped === "Main Hand") > -1){
                        character.inventory[character.inventory.findIndex(i => i.equipped === "Main Hand")].equipped = "";
                    };
                    if(character.inventory.findIndex(i => i.equipped === "Off Hand") > -1){
                        character.inventory[character.inventory.findIndex(i => i.equipped === "Off Hand")].equipped = "";
                    };
                    character.inventory[ind].equipped = "Main Hand";
                } else if(offhand){
                    if(character.inventory.findIndex(i => i.equipped === "Off Hand") > -1){
                        character.inventory[character.inventory.findIndex(i => i.equipped === "Off Hand")].equipped = "";
                    };
                    character.inventory[ind].equipped = "Off Hand";
                } else {
                    if(character.inventory.findIndex(i => i.equipped === "Main Hand") > -1){
                        character.inventory[character.inventory.findIndex(i => i.equipped === "Main Hand")].equipped = "";
                    };
                    character.inventory[ind].equipped = "Main Hand";
                }
                break;
            case "Pistol": {
                if(offhand){
                    if(character.inventory.findIndex(i => i.equipped === "Off Hand") > -1){
                        character.inventory[character.inventory.findIndex(i => i.equipped === "Off Hand")].equipped = "";
                    };
                    character.inventory[ind].equipped = "Off Hand";
                } else {
                    if(character.inventory.findIndex(i => i.equipped === "Main Hand") > -1){
                        character.inventory[character.inventory.findIndex(i => i.equipped === "Main Hand")].equipped = "";
                    };
                    character.inventory[ind].equipped = "Main Hand";
                }
                break;
            }
            default:
                break;
        }

        var recalcDIS = 0;
        var recalcKIN = 0;

        for(var i=0; i < character.inventory.length; i++){
            if(character.inventory[i].classification === 'Armor' && character.inventory[i].equipped !== ''){
                recalcDIS += character.inventory[i].dis;
                recalcKIN += character.inventory[i].kin;
            }
        }

        saveCharacter({
            ...character,
            "currentDIS": recalcDIS,
            "baseDIS": recalcDIS,
            "currentKIN": recalcKIN,
            "baseKIN": recalcKIN,
            "inventory": character.inventory
        });

        closeInventoryOptions();
    }

    const unequipItem = (slot) => (e) => {
        character.inventory[character.inventory.findIndex(i => i.equipped === slot)].equipped = "";

        var recalcDIS = 0;
        var recalcKIN = 0;

        for(var i=0; i < character.inventory.length; i++){
            if(character.inventory[i].classification === 'Armor' && character.inventory[i].equipped !== ''){
                recalcDIS += character.inventory[i].dis;
                recalcKIN += character.inventory[i].kin;
            }
        }

        saveCharacter({
            ...character,
            "currentDIS": recalcDIS,
            "baseDIS": recalcDIS,
            "currentKIN": recalcKIN,
            "baseKIN": recalcKIN,
            "inventory": character.inventory
        });

        closeInventoryOptions();
    }

    const giveToCompanion = (item, comp) => (e) => {

        var curComps = [...character.companions];

        // Save index of selected companion and current state of inventory as vars
        var compInd = curComps.findIndex(x => x.name === comp.name);

        // Create a new companion object with updated inventory
        var newComp = {
            ...comp,
            "inventory": [...comp.inventory, item]
        }

        // Save the new companion data into the variable companion list
        curComps[compInd] = newComp;

        // Update the character's inventory to not include the selected item
        var newCharInv = [...character.inventory]

        var itemInd = newCharInv.findIndex(x => x._id === item._id);
        newCharInv.splice(itemInd, 1);

        // Save character
        saveCharacter({
            ...character,
            "inventory": newCharInv,
            "companions": curComps
        });

        closeInventoryOptions();
    }

    const giveToVehicle = (item, veh) => (e) => {

        var curVehs = [...character.vehicles];

        // Save index of selected companion and current state of inventory as vars
        var vehInd = curVehs.findIndex(x => x.name === veh.name);

        // Create a new companion object with updated inventory
        var newVeh = {
            ...veh,
            "inventory": [...veh.inventory, item]
        }

        // Save the new companion data into the variable companion list
        curVehs[vehInd] = newVeh;

        // Update the character's inventory to not include the selected item
        var newCharInv = [...character.inventory]

        var itemInd = newCharInv.findIndex(x => x._id === item._id);
        newCharInv.splice(itemInd, 1);

        // Save character
        saveCharacter({
            ...character,
            "inventory": newCharInv,
            "vehicles": curVehs
        });

        closeInventoryOptions();
    }

    const addWeaponToVehicle = (item, veh) => (e) => {

        if(veh.weapons.length == veh.weaponSlots){
            alert('Vehicle cannot have any more weapons attached!');
            return;
        }

        var curVehs = [...character.vehicles];

        // Save index of selected companion and current state of inventory as vars
        var vehInd = curVehs.findIndex(x => x.name === veh.name);

        // Create a new companion object with updated inventory
        var newVeh = {
            ...veh,
            "weapons": [...veh.weapons, item]
        }

        // Save the new companion data into the variable companion list
        curVehs[vehInd] = newVeh;

        // Update the character's inventory to not include the selected item
        var newCharInv = [...character.inventory]

        var itemInd = newCharInv.findIndex(x => x._id === item._id);
        newCharInv.splice(itemInd, 1);

        // Save character
        saveCharacter({
            ...character,
            "inventory": newCharInv,
            "vehicles": curVehs
        });

        closeInventoryOptions();
    }

    const openBuyModal = (e) => {
        toggleBuyModal(true);
        closeInventoryOptions();
    }

    const openCraftingModal = (e) => {
        toggleCraftingModal(true);
        closeInventoryOptions();
    }

    const openModModal = (item) => (e) => {
        toggleModModal({"open": true, "item": item});
        closeInventoryOptions();
    }

    const openOffhandModal = (item) => (e) => {
        toggleOffhandModal({"open": true, "item": item});
        closeInventoryOptions();
    }

    const closeModals = (e) => {
        toggleBuyModal(false);
        toggleCraftingModal(false);
        toggleModModal({"open": false, "item": {}})
        toggleOffhandModal({"open": false, "item": {}});
    }

    const {
        funds,
        currentCapacity,
        maxCapacity
    } = character;

    const onChange = e => {
        saveCharacter({
            ...character,
            [e.target.name]: e.target.value
        }, items);
    }

    return (
        <Fragment>
            <div className="char-sheet-inventory-panel">
                <div className="inventory-top-container">
                    <div className="inventory-top-subcontainer">
                        <div className="funds-container">
                            <h1>FUNDS</h1>
                            <input type="number" name="funds" value={funds} onChange={onChange}/>
                        </div>
                        <div className="capacity-container">
                            <h1>CARRYING CAPACITY</h1>
                            
                            <div className="capacity-border">
                                <div className="capacity-fill" style={{width: currentCapacity < maxCapacity ? currentCapacity/maxCapacity*300 + 'px' : 300 + 'px'}}></div>
                                <input type="number" className={currentCapacity > maxCapacity && 'text-danger'} name='currentCapacity' value={currentCapacity}/>/<input type="number" name='maxCapacity' value={maxCapacity} onChange={onChange}/>
                            </div>
                        </div>
                    </div>
                    <div className="action-container">
                        <h1>ACTIONS</h1>
                        <div className="action-button-container">
                            <button name="buy" onClick={openBuyModal}>GET ITEMS</button>
                            <button name="craft" onClick={openCraftingModal}>CRAFTING</button>
                        </div>
                    </div>
                </div>
                <Modal
                    isOpen={showBuyModal}
                    onRequestClose={closeModals}
                    className="itemStore"
                    overlayClassName="itemStoreOverlay"
                >
                    <ItemStore closeStore={closeModals} />
                </Modal>
                <Modal
                    isOpen={showCraftingModal}
                    onRequestClose={closeModals}
                    className="itemStore"
                    overlayClassName="itemStoreOverlay"
                >
                    <CraftingModal closeStore={closeModals} />
                </Modal>
                <Modal
                    isOpen={modModal.open}
                    onRequestClose={closeModals}
                    className="itemStore"
                    overlayClassName="itemStoreOverlay"
                >
                    <ModModal selectedItem={modModal.item} closeStore={closeModals} />
                </Modal>
                <Modal
                    isOpen={offhandModal.open}
                    onRequestClose={closeModals}
                    className="offhandModal"
                    overlayClassName="offhandOverlay"
                >
                    <h1>Choose where to equip this item:</h1>
                    <div>
                        <button onClick={e => equipItem(character.inventory.findIndex(i => i == offhandModal.item), offhandModal.item)(e)}>Main Hand</button>
                        <button onClick={e => equipItem(character.inventory.findIndex(i => i == offhandModal.item), offhandModal.item, true)(e)}>Off Hand</button>
                    </div>
                </Modal>
                <h1 className="lead text-blue">INVENTORY</h1>
                <div className="itemList">
                    {showInventory()}
                </div>
                
            </div>
        </Fragment>
    )
}

CharEditInventory.propTypes = {
    character: PropTypes.object.isRequired,
    saveCharacter: PropTypes.func.isRequired
};

const mapStateToProps = state => ({
    character: state.character,
    item: state.item
});

export default connect(mapStateToProps, {saveCharacter})(CharEditInventory);
